import classNames from 'classnames';
import React from 'react';
import EfImg from '../ef-img';
import './index.scss';

interface EfImgListAItemProps {
    /**
     * 所有分辨率展示的图片链接
     */
    pc: string;
    /**
     * 分辨率小于等于1024时展示的图片链接
     */
    h5?: string;
    /**
     * 标题
     */
    title?: React.ReactNode;
    /**
     * 描述
     */
    desc?: React.ReactNode;
    /**
     * 样式名
     */
    className?: string;
}
interface EfImgListAProps {
    /**
     * 列表
     */
    items: EfImgListAItemProps[];
    /**
     * 样式名
     */
    className?: string;
}

/**
 * 维护:谢保林
 *
 * 底部提示语
 */
const EfImgListA: React.FC<EfImgListAProps> = ({ className, items = [] }) => {
    const prefixCls = `ef-img-list-a`;
    const compCls = classNames(prefixCls, 'ef-container', {
        [`${className}`]: className,
    });

    return (
        <div className={compCls}>
            <div className={`${prefixCls}-in`}>
                {items?.map((item: EfImgListAItemProps, index: number) => (
                    <div key={index} className={`${prefixCls}-item ${prefixCls}-item-${index + 1}`}>
                        <div className={`${prefixCls}-item-img`}>
                            <EfImg pc={item.pc} h5={item.h5} />
                        </div>
                        <div className={`${prefixCls}-item-msg`}>
                            <div className={`${prefixCls}-item-title`}>{item.title}</div>
                            <div className={`${prefixCls}-item-desc`}>{item.desc}</div>
                        </div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default EfImgListA;
